import React from 'react';
import { Box, Typography, SvgIcon, useTheme } from '@mui/material';
import { styled, width } from '@mui/system';

const CustomParkingTicketIcon = (props) => (
    <SvgIcon viewBox="0 0 80 24" {...props}>
        {/* Main rectangular ticket body */}
        <rect x="1" y="3" width="78" height="18" rx="2" fill="currentColor" />

        {/* Dashed line for the tear-off stub */}
        <line x1="13" y1="3" x2="13" y2="21" stroke="#fff" strokeWidth="1" strokeDasharray="2 2" />

        {/* 'P' symbol for Parking on the left stub */}
        <path
            d="M5 7h2.5c1.4 0 2.5 1.1 2.5 2.5S8.9 12 7.5 12H6.5v4h-1.5V7zm1.5 1.5v2h1c.6 0 1-.4 1-1s-.4-1-1-1h-1z"
            fill="#fff"
        />
    </SvgIcon>
);

const Wrapper = styled("div")(({ theme }) => ({
    width: "100px",
    margin: "5px 1px",
}));

const ParkingTicket = ({ ticketNumber }) => {
    const {palette} = useTheme();

    return (
        <Box
            component="span"
            sx={{
                position: 'relative',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                verticalAlign: 'middle', // Ensures it stays inline with surrounding normal text
                mx: 0.5, // Adds a slight margin so it doesn't bump into surrounding words
            }}
        >
            {/* Background Ticket Icon */}
            <CustomParkingTicketIcon
                sx={{
                    fontSize: '32px',
                    width: '100px',
                    color: palette.primary.main,
                }}
            />
            <Typography
                component="span"
                sx={{
                    position: 'absolute',
                    color: palette.primary.contrastText,
                    fontWeight: 800,
                    fontSize: "9px",
                    paddingLeft: 1,
                }}
            >
                {ticketNumber}
            </Typography>
        </Box>
    );
};

export default ParkingTicket;